import { createContext } from 'react';
import initialSalesMatchingState from './initialSalesMatchingState';

const SalesMatchingContext = createContext(initialSalesMatchingState);

export default SalesMatchingContext;
